import { io, ManagerOptions, Socket, SocketOptions } from "socket.io-client";

import { getAccessToken } from "./storage.service";
import { getWebSocketUrl } from "./websocket-url";

export function createNamespaceSocket(
  namespace: string,
  extraOptions: Partial<ManagerOptions & SocketOptions> = {},
): Socket | null {
  const token = getAccessToken();
  const url = getWebSocketUrl();
  if (!token || !url) {
    return null;
  }

  return io(`${url}/${namespace}`, {
    path: "/socket.io",
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    ...extraOptions,
  });
}
